import NonTissueItemIcon from 'src/assets/images/NonTissueItemIcon.svg';
import StepperAddBlue from 'src/assets/images/StepperAddBlue.svg';
import AlertCircleOutline from 'src/assets/images/AlertCircleOutline.svg';
import React, { useState, useRef, useCallback } from 'react';
import { sizes } from 'src/styles/Media.styled';
import {
    ItemListViewWrapper,
    ItemTable, 
    id
} from './index.styled.jsx';
import { isTransferSurgery, logErrorToConsole } from 'src/utils/util';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import warning from 'src/assets/images/warning.svg';
import { ProductErrorText,AlertIcon } from '../../../pages/scheduleSurgery/components/shipping/NonTissueProductCard.styled';
import { setItemLoader } from 'src/pages/equity/redux/actions';
import CheckBoxTransfer from './CheckBoxTransfer';
import TableHeaderData from './TableHeaderData';
import ListViewBundleExpansionRow from './ListViewBundleExpansionRow';
import MobileProductCard from './MobileProductCard';
import ListViewTableRow from './ListViewTableRow';
import { ORANGE_FONT_COLOR, GREY_PRODUCT_LIST_COLOR } from '../../../styles/fonts/MCFontConstants';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const ListView = ({
    products,
    isOrderScreen = false,
    isForProductGuide = false,
    setProductToBeAdded = () => { },
    productValidation,
    handleSetItemClick = () => { },
    setsQuantityCheck = () => { },
    removeCount = () => { },
    addCount = () => { },
    deleteProduct = () => { },
    isShippingScreen = false,
    isReviewSubmitScreen = false,
    inventoryShipping = false,
    handleLocationChange = () => { },
    checkAll = false,
    checkSelectAllDisabled = () => { },
    selectAllDisabled = '',
    handleShipAllChange = () => { },
    isItem = false,
    selectedLocation,
    isTemplateScreen = false,
    handleCheckBoxSelection = () => { },
    moreTemplates = false,
    isEquityTemplate = false,
    isEquityPage = false,
    isReviewSubmitScreenEquity,
    onBomClick = () => { },
    showDontShip = true,
    isCartScreen = false,
    isFromTemplates = false,
    isSurgery = false,
    isBatchSelected = false,
    setIsBatchSelected = () => { },
    isSubItem = false,
    isBundleView = false,
    handleBundlePopup = () => { },
    handleBundleSetItemClick = () => { },
    isItemBundlePopup = false,
    isImplant,
    productKeyBundle = '',
    isTemplateDetail = false,
    parentIndex = '',
    isAddToBundle = false,
    updateProductQuantity = () => { },
    isQuickOrder,
    isForSetItem,
    isOnlyPlusButton,
    isConsignmentAdd,
    isEquity,
    handleAddToCartSynchronized,
    isFromIndependentProductGuide = false,
    isFromSetItemDetailsLists = false,
    marginBottom,
    isQuickOrderEquityTemplate = false,
    cartProducts = [],
    isFromEquity = false,
}) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const winWidth = window.innerWidth;
    const isMobileView = winWidth < sizes.smalDevice;
    const ipadMini = winWidth === sizes.smalDevice;
    const isTabletView =
        winWidth >= sizes.smalDevice && winWidth <= sizes.mediumDevice;
    const countryISOCode = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.countryISOCode
    );

    useEffectWithErrorLogging(() => {
        const timer = setTimeout(() => {
            try {
            dispatch(setItemLoader(false));
            } catch (error) {
                logErrorToConsole(error);
            }
        }, 1500);

        return () => clearTimeout(timer);
    }, [products]);

    const isCondensedView = useSelector(
        (state) => state.loginReducer.isCondensedView
    );
    const shipDontShipSurgery = useSelector(
        (state) => state.loginReducer.shipDontShipSurgery
    );
    const productWithIsPlaceHolderSet = useSelector(
        (state) => state.surgeryDetailsReducer.productWithIsPlaceHolderSet
    );
    const isItemListView = useSelector(
        (state) => state.orderSummaryReducer.isItemListView
    );
    const orderType = useSelector(
        (state) => state.orderSummaryReducer?.orderBasicDetails?.currentOrderType
    );
    const currencyISOCode = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.currencyISOCode
    );

    const [allocatedData, setAllocatedData] = useState('');
    const [expandedItems, setExpandedItems] = useState({});
    const [quantityValue, setQuantityValue] = useState(0);

    // Rate limiting for rapid clicks - prevent race conditions
    const lastClickTimeRef = useRef({});
    const isClickAllowed = (itemKey) => {
        const now = performance.now(); // Use high precision timestamp instead of Date.now()
        const lastClickTime = lastClickTimeRef.current[itemKey] || 0;
        const timeDiff = now - lastClickTime;

        // Only block if the SAME item is clicked too rapidly (50ms for same item)
        if (timeDiff < 50) { 
            return false;
        }

        lastClickTimeRef.current[itemKey] = now; 
        return true;
    };

    // Cleanup effect to prevent memory leaks
    useEffectWithErrorLogging(() => {
        return () => {
            lastClickTimeRef.current = {};
        };
    }, []);

    // Cleanup effect to prevent memory leaks
    useEffectWithErrorLogging(() => {
        return () => {
            lastClickTimeRef.current = {};
        };
    }, []);

    const removeLeadingZeros = (val) => String(val).replace(/^0+/, '') || '0';

    const validateQuantity = useCallback((value, productKeyBundle, itemProductKey) => {
    const limitTwoDigits = /^\d{0,2}$/;
    const valuedigits = value;
    const removeLeadingZeroValue = removeLeadingZeros(value);
    if (removeLeadingZeroValue > 50) {
        setsQuantityCheck(true);
        return;
    }
    if (limitTwoDigits.test(valuedigits)) {
        updateProductQuantity(
            removeLeadingZeroValue,
            productKeyBundle ? productKeyBundle : itemProductKey,
            productKeyBundle ? itemProductKey : ''
        );
        setQuantityValue(removeLeadingZeroValue);
    }
    }, [removeLeadingZeros, setsQuantityCheck, updateProductQuantity]);

    // Toggle expansion for a specific item
    const toggleItem = (itemId) => {
        setExpandedItems((prev) => ({
            ...prev,
            [itemId]: !prev[itemId],
        }));
    };

    const getMaxLength = useCallback((type) => {
    if (type === 'description') {
        return isOrderScreen ? 47 : isTabletView ? 42 : 60;
    }
    if (type === 'brand') {
        return isOrderScreen ? 22 : 30;
    }
    return 0;
}, [isOrderScreen, isTabletView]);

    const { productBomDetails } = useSelector(
        (state) => state.checkProductBomReducer
    ); 
    const isTissueProduct =
        (products?.length > 0 && products[0]?.salesOrg === 'S030') ?? false;
    const [reservationBatch, setReservationBatch] = useState('');
    const isTablet = winWidth >= 768 && winWidth < 1024;
    const isIPadPro = winWidth >= 1024 && winWidth <= 1366;
    if (!products || products?.length === 0) {
        return null;
    }



    const renderDesktopView = () => (
        <>
            <ItemTable borderBottom={isSubItem && 'none'}>
                <TableHeaderData
                    isForProductGuide={isForProductGuide}
                    isSurgery={isSurgery}
                    isTablet={isTablet}
                    countryISOCode={countryISOCode}
                    isAddToBundle={isAddToBundle}
                    isIPadPro={isIPadPro}
                    isEquityPage={isEquityPage}
                    isSubItem={isSubItem}
                    isForSetItem={isForSetItem}
                    isQuickOrder={isQuickOrder}
                    isShippingScreen={isShippingScreen}
                    isReviewSubmitScreen={isReviewSubmitScreen}
                    isReviewSubmitScreenEquity={isReviewSubmitScreenEquity}
                    isOrderScreen={isOrderScreen}
                    isBundleView={isBundleView}
                    isTemplateScreen={isTemplateScreen}
                    isEquityTemplate={isEquityTemplate}
                    isTemplateDetail={isTemplateDetail}
                    isItemListView={isItemListView}
                    orderType={orderType}
                    isFromTemplates={isFromTemplates}
                    isCondensedView={isCondensedView}
                    showDontShip={showDontShip}
                    isItem={isItem}
                    shipDontShipSurgery={shipDontShipSurgery}
                    checkAll={checkAll}
                    handleShipAllChange={handleShipAllChange}
                    isImplant={isImplant}
                    checkSelectAllDisabled={checkSelectAllDisabled}
                    products={products}
                    selectAllDisabled={selectAllDisabled}
                    ipadMini={ipadMini}
                    isTissueProduct={isTissueProduct}
                    currencyISOCode={currencyISOCode}
                    isFromIndependentProductGuide={isFromIndependentProductGuide}
                    isItemBundlePopup={isItemBundlePopup}
                />
                <tbody>
                    {products
                        ?.filter((item) => !item?.isTemplateEntryDeleted)
                        ?.map(
                            (item, index) => {
                                // Don't filter by basePrice in bundle popup - show all bundle items
                                const shouldRender = isItemBundlePopup ? true : (isEquityPage && isCartScreen && !isSubItem
                                    ? (isQuickOrder ? true : item?.basePrice !== undefined)
                                    : true);
                                
                                return shouldRender && (
                                    <>
                                        <ListViewTableRow 
                                            index = {index}
                                            cartProducts={cartProducts}
                                            parentIndex = {parentIndex}
                                            isSubItem = {isSubItem}
                                            isBundleView = {isBundleView}
                                            item = {item}
                                            expandedItems = {expandedItems}
                                            countryISOCode = {countryISOCode}
                                            isReviewSubmitScreenEquity = {isReviewSubmitScreenEquity}
                                            isForProductGuide = {isForProductGuide}
                                            isForSetItem = {isForSetItem}
                                            isSurgery = {isSurgery}
                                            isTablet = {isTablet}
                                            toggleItem = {toggleItem}
                                            isQuickOrder = {isQuickOrder}
                                            handleSetItemClick = {handleSetItemClick}
                                            isTemplateScreen = {isTemplateScreen}
                                            isReviewSubmitScreen = {isReviewSubmitScreen}
                                            isShippingScreen = {isShippingScreen}
                                            isOrderScreen = {isOrderScreen}
                                            productBomDetails = {productBomDetails}
                                            onBomClick = {onBomClick}
                                            winWidth = {winWidth}
                                            NonTissueItemIcon = {NonTissueItemIcon}
                                            isFromSetItemDetailsLists = {isFromSetItemDetailsLists}
                                            getMaxLength = {getMaxLength}
                                            isItemListView = {isItemListView}
                                            orderType = {orderType}
                                            isFromTemplates = {isFromTemplates}
                                            isCondensedView = {isCondensedView}
                                            isAddToBundle = {isAddToBundle}
                                            handleCheckBoxSelection = {handleCheckBoxSelection}
                                            productKeyBundle = {productKeyBundle}
                                            productWithIsPlaceHolderSet = {productWithIsPlaceHolderSet}
                                            inventoryShipping = {inventoryShipping}
                                            showDontShip = {showDontShip}
                                            shipDontShipSurgery = {shipDontShipSurgery}
                                            handleLocationChange = {handleLocationChange}
                                            selectedLocation = {selectedLocation}
                                            allocatedData = {allocatedData}
                                            checkAll = {checkAll}
                                            setIsBatchSelected = {setIsBatchSelected}
                                            isBatchSelected = {isBatchSelected}
                                            setAllocatedData = {setAllocatedData}
                                            setReservationBatch = {setReservationBatch}
                                            isCartScreen = {isCartScreen}
                                            moreTemplates = {moreTemplates}
                                            removeCount = {removeCount}
                                            isItemBundlePopup = {isItemBundlePopup}
                                            isEquityPage = {isEquityPage}
                                            isEquityTemplate = {isEquityTemplate}
                                            validateQuantity = {validateQuantity}
                                            addCount = {addCount}
                                            isFromIndependentProductGuide = {isFromIndependentProductGuide}
                                            isClickAllowed = {isClickAllowed}
                                            handleAddToCartSynchronized = {handleAddToCartSynchronized}
                                            setProductToBeAdded = {setProductToBeAdded}
                                            isConsignmentAdd = {isConsignmentAdd}
                                            productValidation = {productValidation}
                                            StepperAddBlue = {StepperAddBlue}
                                            isEquity = {isEquity}
                                            isOnlyPlusButton = {isOnlyPlusButton}
                                            deleteProduct = {deleteProduct}
                                            isQuickOrderEquityTemplate= {isQuickOrderEquityTemplate}
                                            isFromEquity={isFromEquity}
                                        />
                                        {item.batchAllocationError &&
                                            isShippingScreen && (
                                                <tr
                                                    style={{
                                                        backgroundColor:
                                                            index % 2 === 0
                                                                ? 'white'
                                                                : GREY_PRODUCT_LIST_COLOR,
                                                        borderBottom:
                                                            '1px solid #ddd',
                                                    }}
                                                >
                                                    <td
                                                        colSpan="5"
                                                        className="full-width"
                                                    >
                                                        <ProductErrorText
                                                            style={{
                                                                padding:
                                                                    '0 0 0 19px',
                                                                marginTop:
                                                                    '-13px',
                                                            }}
                                                        >
                                                            <AlertIcon
                                                                src={
                                                                    AlertCircleOutline
                                                                }
                                                                height="14px"
                                                                width="auto"
                                                            />
                                                            <div>
                                                                {t(
                                                                    'scheduleSurgery.Shipping.ProductCard.batchAllocationError'
                                                                )}
                                                            </div>
                                                        </ProductErrorText>
                                                    </td>
                                                </tr>
                                            )}
                                        {expandedItems[
                                            item.productKey || index
                                        ] &&
                                            (item?.children ||
                                                item?.bundleItems) && (

                                                <ListViewBundleExpansionRow
                                                    item={item}
                                                    index={index}
                                                    isOrderScreen={isOrderScreen}
                                                    isTemplateDetail={isTemplateDetail}
                                                    isReviewSubmitScreenEquity={isReviewSubmitScreenEquity}
                                                    handleBundlePopup={handleBundlePopup}
                                                    handleBundleSetItemClick={handleBundleSetItemClick}
                                                    isEquityTemplate={isEquityTemplate}
                                                    setsQuantityCheck={setsQuantityCheck}
                                                    handleSetItemClick={handleSetItemClick}
                                                    addCount={addCount}
                                                    removeCount={removeCount}
                                                    deleteProduct={deleteProduct}
                                                    isCartScreen={isCartScreen}
                                                    isEquityPage={isEquityPage}
                                                    isCondensedView={isCondensedView}
                                                    isShippingScreen={isShippingScreen}
                                                    isReviewSubmitScreen={isReviewSubmitScreen}
                                                    inventoryShipping={inventoryShipping}
                                                    moreTemplates={moreTemplates}
                                                    isFromTemplates={isFromTemplates}
                                                    isSurgery={isSurgery}
                                                    isTemplateScreen={isTemplateScreen}
                                                    handleCheckBoxSelection={handleCheckBoxSelection}
                                                    updateProductQuantity={updateProductQuantity}
                                                    isEquity={isEquity}
                                                    isQuickOrder={isQuickOrder}
                                                    expandedItems={expandedItems}
                                                />
                                            )}

                                        {isCartScreen &&
                                            item?.businessRules &&
                                            item?.businessRules?.length > 0
                                            ? item?.businessRules.map(
                                                (msg, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td
                                                                colSpan="5"
                                                                className="full-width"
                                                            >
                                                                <ProductErrorText
                                                                    style={{
                                                                        padding:
                                                                            '0 0 0 19px',
                                                                    }}
                                                                >
                                                                    <AlertIcon
                                                                        src={
                                                                            warning
                                                                        }
                                                                        height="14px"
                                                                        width="auto"
                                                                    />
                                                                    <div
                                                                        style={{
                                                                            color: ORANGE_FONT_COLOR,
                                                                        }}
                                                                    >
                                                                        {
                                                                            msg?.subType
                                                                        }
                                                                        {'-'}
                                                                        {
                                                                            msg.message
                                                                        }
                                                                    </div>
                                                                </ProductErrorText>
                                                            </td>
                                                        </tr>
                                                    );
                                                }
                                            )
                                            : null}
                                        {isShippingScreen &&
                                            isTransferSurgery() &&
                                            item.status &&
                                            (countryISOCode === 'JP'
                                                ? item.status !==
                                                'Not Allocated'
                                                : true) && (
                                                <tr
                                                    style={{
                                                        backgroundColor:
                                                            index % 2 === 0
                                                                ? 'white'
                                                                : GREY_PRODUCT_LIST_COLOR,
                                                        borderBottom:
                                                            '1px solid #ddd',
                                                    }}
                                                >
                                                    <td
                                                        colSpan="6"
                                                        className="full-width"
                                                        style={{
                                                            padding:
                                                                '0 0 0 9px',
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                marginTop:
                                                                    '-2px',
                                                            }}
                                                        >
                                                            <CheckBoxTransfer
                                                                item={item}
                                                                inventoryShipping={
                                                                    inventoryShipping
                                                                }
                                                                countryISOCode={
                                                                    countryISOCode
                                                                }
                                                                handleLocationChange={
                                                                    handleLocationChange
                                                                }
                                                                checked={
                                                                    !item.shippingRequirement
                                                                }
                                                                selectedLocation={
                                                                    selectedLocation
                                                                }
                                                                allocatedData={
                                                                    allocatedData
                                                                }
                                                                isShowCheckBox={
                                                                    false
                                                                }
                                                                isMessageDisplay={
                                                                    true
                                                                }
                                                                isShowLabelEmpty={
                                                                    false
                                                                }
                                                                isShowDropDown={
                                                                    false
                                                                }
                                                            />
                                                        </div>
                                                        {/*end transfer surgery check*/}
                                                    </td>
                                                </tr>
                                            )}
                                    </>
                                );
                            }
                        )}
                </tbody>
            </ItemTable>
        </>
    );

    const renderMobileView = () =>
        products?.map((item, index) => (
            <MobileProductCard
                key={index}
                item={{ ...item, isLast: index === products.length - 1 }}
                index={index}
                handleSetItemClick={handleSetItemClick}
            />
        ));

    // Detect iPhone SE landscape
    const isIphoneSELandscape =
        typeof window !== 'undefined' &&
        window.screen &&
        ((window.screen.width === 667 && window.screen.height === 375) ||
            (window.screen.width === 375 && window.screen.height === 667)) &&
        window.innerWidth > window.innerHeight;


    return (
        <>
            <ItemListViewWrapper
                id={isForSetItem && id}
                width={isOrderScreen && '100%'}
                padding={!isOrderScreen && '0 5% 6% 5%'}
                desktopPading={isSubItem && '0 2%'}
                marginBottom={marginBottom}
            >
                {(!isMobileView || isIphoneSELandscape)
                    ? renderDesktopView()
                    : renderMobileView()}
            </ItemListViewWrapper>
        </>
    );
};

export default ListView;
